import { render, staticRenderFns } from "./MatColorSelector.vue?vue&type=template&id=9ba2a50c&scoped=true&"
import script from "./MatColorSelector.vue?vue&type=script&lang=ts&"
export * from "./MatColorSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MatColorSelector.vue?vue&type=style&index=0&id=9ba2a50c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba2a50c",
  null
  
)

export default component.exports